import Skeleton from 'react-loading-skeleton';
import { styled } from 'goober';

import { colors } from '@/theme/colors';
import { Inline } from '@/ui/line/line';
import { Stack } from '@/ui/line/line';

export const PendingRequestCardSkeleton = () => {
  return (
    <Container gap="20px">
      <Inline justifyContent="space-between" alignItems="start">
        <Inline alignItems="center" gap="12px">
          <Skeleton circle width={40} height={40} />
          <Stack gap="4px">
            <Skeleton height={16} width={150} />
            <Skeleton height={12} width={120} />
          </Stack>
        </Inline>
        <Skeleton height={12} width={80} />
      </Inline>

      <Skeleton height={14} width="100%" />
      <Skeleton height={14} width="80%" />

      <Inline gap="16px" justifyContent="start">
        <Skeleton height={40} width={140} borderRadius={8} />
        <Skeleton height={40} width={100} borderRadius={8} />
      </Inline>
    </Container>
  );
};

const Container = styled(Stack)`
  border-radius: 10px;
  border: 1px ${colors.gray.c3} solid;
  padding: 32px;
  background-color: ${({ theme }) => theme.colors.basics.white};
  max-width: 670px;
`;
